var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "廠區",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "factoryCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入廠區" },
                            model: {
                              value: _vm.model.factoryCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "factoryCode", $$v)
                              },
                              expression: "model.factoryCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "法人",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "companyCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入法人" },
                            model: {
                              value: _vm.model.companyCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "companyCode", $$v)
                              },
                              expression: "model.companyCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "siteId",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "siteCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入siteId" },
                            model: {
                              value: _vm.model.siteCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "siteCode", $$v)
                              },
                              expression: "model.siteCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "費用代碼",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "costCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入費用代碼" },
                            model: {
                              value: _vm.model.costCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "costCode", $$v)
                              },
                              expression: "model.costCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "事業群",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "bgCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入事業群" },
                            model: {
                              value: _vm.model.bgCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "bgCode", $$v)
                              },
                              expression: "model.bgCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "在職/離職",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "jobSt"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入在職/離職" },
                            model: {
                              value: _vm.model.jobSt,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "jobSt", $$v)
                              },
                              expression: "model.jobSt"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "人員類型",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empType"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入人員類型" },
                            model: {
                              value: _vm.model.empType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empType", $$v)
                              },
                              expression: "model.empType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "备注",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入备注" },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }